import React from 'react';
import Layout from '@/components/layout/Layout';
import BatchTraceabilityReport from '@/components/reports/BatchTraceabilityReport';

const BatchTraceabilityReportPage: React.FC = () => {
  return (
    <Layout>
      <BatchTraceabilityReport />
    </Layout>
  );
};

export default BatchTraceabilityReportPage;
